import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BorrowerTypeEnum,
  ENVIRONMENT,
  TcpaEntity,
  TcpaUpdateRequest,
  TcpaUpdateResponse,
} from '@ld.consumer-portal/models';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TcpaService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);

  private get borrowersBaseUrl(): string {
    return this.env.appSettings.ServicingLINCPortalBorrowers || '';
  }

  private get apiNamespace(): string {
    return this.env.appSettings.apiNamespace || 'api/v1';
  }

  async getTcpaDetails(
    loanNumber: string,
    encryptionValue: string,
    borrowerType: BorrowerTypeEnum,
    borrowerId: string
  ): Promise<TcpaEntity> {
    const url = `${this.borrowersBaseUrl}/${this.apiNamespace}/ServicingLINCPortal/Tcpa/${loanNumber}`;

    const params = {
      encryptionValue,
      borrowerType: borrowerType.toString(),
      borrowerId,
    };

    return firstValueFrom(this.http.get<TcpaEntity>(url, { params }));
  }

  async updateTcpaConsent(loanNumber: string, request: TcpaUpdateRequest): Promise<TcpaUpdateResponse> {
    const url = `${this.borrowersBaseUrl}/${this.apiNamespace}/ServicingLINCPortal/Tcpa/Consent/${loanNumber}`;

    return firstValueFrom(this.http.post<TcpaUpdateResponse>(url, request));
  }

  async submitConsent(loanNumber: string, request: TcpaUpdateRequest): Promise<TcpaUpdateResponse> {
    return this.updateTcpaConsent(loanNumber, {
      ...request,
      isConsented: true,
    });
  }

  async declineConsent(loanNumber: string, request: TcpaUpdateRequest): Promise<TcpaUpdateResponse> {
    return this.updateTcpaConsent(loanNumber, {
      ...request,
      isConsented: false,
    });
  }
}
